import { Component, OnInit } from '@angular/core';
import {FormControl} from '@angular/forms';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { AuthServicesService } from 'src/app/services/auth-services.service';
import { FirebaseFunctionsService } from 'src/app/services/firebase-functions.service';

@Component({
  selector: 'app-profil',
  templateUrl: './profil.component.html',
  styleUrls: ['./profil.component.scss']
})
export class ProfilComponent implements OnInit {

  userFirstname: string = '';
  userLastName: string = '';
  userEmail: string = '';
  userEcoleName: string = '';
  userType: string = '';
  isUserClassesEmpty: boolean = true;
  userClasses: Observable<any> | null = null;
  className: string = '';
  classLevel: any[] = [];
  classCode: string = '';
  userProfileImg: Observable<any>;
  imgGot: boolean = false;

  constructor(private afs: FirebaseFunctionsService,private app: AppComponent,private authService: AuthServicesService) {
    const typeUser = sessionStorage.getItem('userType');
    if (typeUser == 'administrateur') {
      this.app.navigateTo('/admin');
    }
  }

  ngOnInit(): void {
    this.getUserData();
    this.getUserClasses();
    setTimeout(this.app.afficherPage,2000);
    this.reinitializeMenus();
    document.querySelector('.menu_accueil').classList.add('selected');
  }
  getUserData(){
    const uid = sessionStorage.getItem('userId');
    this.afs.getUtilisateur(uid).forEach( user => {
      this.userFirstname = user['prenom'];
      this.userLastName = user['nom'];
      this.userEmail = user['email'];
      this.afs.getEcole(user['ecole_id']).subscribe( ecole => {
        this.userEcoleName = ecole['nom'];
      });
      this.afs.getProfilePicture(uid).subscribe( imgs => {
        this.userProfileImg = this.afs.getImgUrlFromFireStorage(`/utilisateurs/${uid}/profilePicture/${imgs.items[0]['name']}`);
        this.imgGot = (imgs.items.length < 1)? false: true;
      });
    });
  }
  reinitializeMenus(){
    const menusTabs = document.querySelectorAll('.menus_tab');
    menusTabs.forEach( tabs => {
      (tabs as HTMLElement).classList.remove('selected');
    })
  }
  getUserClasses(){
    const uid = sessionStorage.getItem('userId');
    this.afs.getUtilisateur(uid).forEach( user => {
      this.userType = user['typeUtilisateur'];
      if(this.userType != 'enseignant'){
        this.userClasses = this.afs.getParticipantClasses(uid);
        this.afs.getParticipantClasses(uid).forEach( data => {
          if(data.length == 0){
            this.isUserClassesEmpty = true;
          }else{
            this.isUserClassesEmpty = false;
          }
        })
      }else{
        this.userClasses = this.afs.getEnseignantClasses(uid);
        this.afs.getEnseignantClasses(uid).forEach( data => {
          if(data.length == 0){
            this.isUserClassesEmpty = true;
          }else{
            this.isUserClassesEmpty = false;
          }
        })
      }
    })
  }
  manageClasseModal(){
    const classModal = document.querySelector('.classes_modal') as HTMLElement;
    classModal.style.display = (classModal.style.display !== 'block') ? 'block': 'none';
  }
  classCodeValidation(): boolean{
    const cdcRegex = /^cdc[0-9a-zA-Z]{11}$/;
    return (this.classCode.trim().match(cdcRegex)) ? true: false;
  }
  joinClasse(){
    if(this.classCodeValidation()){
      this.afs.isClasseExists(this.classCode).forEach( res => {
        if(res.exists){
          const uid = sessionStorage.getItem('userId');
          this.afs.joinClasse(this.classCode, uid);
          this.manageClasseModal();
        }else{
          this.afs.showMessage(3,'Cette classe n\'existe pas.', 3000);
        }
      });
    }else{
      this.app.showMessage(3,'Le code de classe doit commencer par \'cdc\' suivi de 9 à 12 caractères alphanumériques', 5000);
    }
  }
  isClasseLevelValide(){
    return (this.classLevel.length == 0)? false: true;
  }
  isClasseNameValide(){
    const classNameRegex = /^([a-zA-Z0-9]|[a-zA-Z0-9\s-_+\/\@]{2,15})$/;
    return(this.className.trim().match(classNameRegex))? true: false;
  }
  addClasse(){
    const classLevelValid = this.isClasseLevelValide();
    const classNameValid = this.isClasseNameValide();
    if(classLevelValid && classNameValid){
      this.className = this.className.charAt(0).toUpperCase() + this.className.slice(1);
      this.afs.addClasse2(sessionStorage.getItem('userId'),this.className.trim(),this.classLevel);
      this.className = '';
      this.manageClasseModal();
    }else{
      if(!classNameValid){
        this.afs.showMessage(3,'Veuillez saisir un nom de classe.',3000);
      }
    }
  }
  changerPhoto(){
    const img = document.querySelector('.profil_avatar') as HTMLImageElement;
    const file = document.querySelector('#file') as HTMLInputElement;
    file.click();
  }
  uploadImg(input: HTMLInputElement){
    const file = input.files[0];
    if( file['type'].split('/')[0] == 'image'){
      this.deletePreviousPictures().then( value => {
        if(value == true){
          this.afs.uploadUserProfileImg(`/utilisateurs/${sessionStorage.getItem('userId')}/profilePicture/avatar.${file['type'].split('/')[1]}`,file).then( () => {
            this.afs.showMessage(1, 'Nouvelle photo de profile téléversée avec succes', 3000);
            this.getUserData();
          });
        }
      });
    }else{
      this.afs.showMessage(3,'Veuillez téléverser une image s.v.p',3000);
    }
  }
  deletePreviousPictures(){
    const uid = sessionStorage.getItem('userId');
    return this.afs.getProfilePicture(uid).forEach( imgs => {
      if(imgs.items.length > 0){
        imgs.items.forEach( img => {
          img.delete();
        });
      }
    }).then( () => true).catch( () => false);
  }
  confirmedChange(){
    const img = document.querySelector('.profil_avatar') as HTMLImageElement;
    const file = document.querySelector('#file') as HTMLInputElement;
    img.src = URL.createObjectURL(file.files[0]);
    this.uploadImg(file);
  }
  signOut(){
    this.authService.signOut();
  }

}
